import Vue from "vue";
//获取nft标签列表
// export function getnftlist(params) {
//   return Vue.$axios({
//     url: "/api/wallet/nft_wallet/albumList",
//     method: "get",
//     params,
//   });
// }
export function httpCoinCode(data) {
  return Vue.$axios({
    url: "/api/wallet/hd_account/address",
    method: "post",
    data,
  });
}
//获取nft详情接口
// export function getnftdetail(data) {
//   return Vue.$axios({
//     url: "/api/wallet/nft_wallet/collectionList",
//     method: "post",
//     data,
//   });
// }
export function addnewnft(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/addCollection",
    method: "post",
    data,
  });
}
// 删除收藏
export function delCollection(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/delCollection",
    method: "post",
    data,
  });
}
// 删除专辑
export function delAlbum(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/delAlbum",
    method: "post",
    data,
  });
}

// 所有专辑列表（内容新版）
export function getallCollection(params) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/allCollection",
    method: "get",
    params,
  });
}
// 转出nft
export function outNftwithdraw(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/withdraw",
    method: "post",
    data,
  });
}
// nft转出记录
export function outNftwithdrawLog(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/withdrawLog",
    method: "post",
    data,
  });
}
// nft转出详情
export function outNftwithdrawInfo(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/withdrawInfo",
    method: "post",
    data,
  });
}
//nft数量
export function outNftdata(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_data/data",
    method: "post",
    data,
  });
}
// 同合约下的tokeid
export function outNfttokenid(data) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/collectionTokenids",
    method: "post",
    data,
  });
}
// 同合约下的tokeid
// 所有专辑列表（内容新版）
export function mynftaddress(params) {
  return Vue.$axios({
    url: "/api/wallet/nft_wallet/addressInfo",
    method: "get",
    params,
  });
}
